import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {DashboardComponent} from './modules/dashboard/dashboard.component';
import { LoggedInGuard } from './guards/logged-in.guard';
import {ErrorPageComponent} from '@npm.chapps.com/chapps.common.angular.library';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'error-page', component: ErrorPageComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [LoggedInGuard] },
  { path: 'notifications', loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule), canActivate: [LoggedInGuard]},
  { path: 'residents', loadChildren: () => import('./modules/residents/residents.module').then(m => m.ResidentsModule), canActivate: [LoggedInGuard]},
  { path: 'announcements', loadChildren: () => import('./modules/announcements/announcements.module').then(m => m.AnnouncementsModule), canActivate: [LoggedInGuard]},
  { path: 'documents', loadChildren: () => import('./modules/documents/documents.module').then(m => m.DocumentsModule), canActivate: [LoggedInGuard] },
  { path: 'businessstyle', loadChildren: () => import('./modules/application-style/application-style.module').then(m => m.ApplicationStyleModule), canActivate: [LoggedInGuard] },
  { path: 'email', loadChildren: () => import('./modules/emails/emails.module').then(m => m.EmailsModule) },
  { path: 'logins', loadChildren: () => import('./modules/logins/logins.module').then(m => m.LoginsModule), canActivate: [LoggedInGuard] },
  { path: '**', redirectTo: '/dashboard'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
